export type PropagandeReview = {
  quote: string;
  source: string;
  url?: string;
};

export const propagandeSectionContent = {
  kicker: "Propagande",
  heading: "Ils ont dit",
  intro:
    "La presse officielle a parlé, ou, du moins, elle a essayé. Voici ce qu'on en a retenu.",
  reviews: [
    {
      quote:
        "Objectivement le meilleur spectacle que j'ai vu de ma vie, ne pas le voir serait une faute grave.",
      source: "Les Apprentis Journalistes",
      url: "https://example.com/article",
    },
    {
      quote:
        "J'ai abandonné toute activité professionnelle pour leur trouver des salles de spectacle !",
      source: "Les Apprentis Organisateurs",
      url: "https://example.com/article",
    },
  ] satisfies PropagandeReview[],
} as const;
